import { Button, Modal, Tooltip } from "antd";
import { useState } from "react";
import TableSettingsItem from "./table-settings-item";
import SportTooltip from "../sport-tooltip/sport-tooltip";
import "./table-settings.css";

const TableSettings = ({ name, columns, onClose, onSettingsChange }) => {
  const [localColumns, setLocalColumns] = useState(columns);

  const onItemClick = (idx) => {
    const newHidden = localColumns.map((item, idx2) => idx === idx2 ? !item.hidden : item.hidden);
    saveSettins(name, JSON.stringify(newHidden));
    const updatedColumns = localColumns.map((item, idx2) => idx === idx2 ? { ...item, hidden: !item.hidden } : item);
    setLocalColumns(updatedColumns);
    onSettingsChange && onSettingsChange();
  };

  const onReset = () => {
    saveSettins(name, null);
    setLocalColumns(columns);
    onSettingsChange && onSettingsChange();
  };

  return (
    <Modal open onCancel={onClose} footer={null} width={300}>
      <div className="table-settins">
        {localColumns.map((column, idx) => (
          <TableSettingsItem
            column={column}
            key={idx}
            onClick={() => onItemClick(idx)}
          />
        ))}
        <Button onClick={onReset}>По умолчанию</Button>
      </div>
    </Modal>
  );
};

// ---- helpers ----
const loadSettins = (name) => {
  if (!name) return null;
  try {
    const data = localStorage.getItem(name);
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
};

const saveSettins = (name, settings) => {
  if (!name) return;
  if (settings === null) localStorage.removeItem(name);
  else localStorage.setItem(name, settings);
};

/**
 * Оборачивает title в Tooltip (если hint)
 * и применяет сохранённые настройки или defaultHiddenColumns.
 */
export const tblGetColumns = (columns, name, defaultHiddenColumns = []) => {
  const newColumns = columns.map((item) => item.hint ? {...item, title: (<Tooltip title={item.hint} color="green">{item.title}</Tooltip>),}: item);
  const settings = loadSettins(name);
  if (settings) {
    return newColumns.map((column, idx) => ({
      ...column,
      hidden: settings[idx] ?? false,
    }));
  }
  // если настроек нет, скрываем defaultHiddenColumns по dataIndex
  return newColumns.map((column) => ({
    ...column,
    hidden: defaultHiddenColumns.includes(column.dataIndex),
  }));
};

export const BtnSettingsTable = ({ name, columns, onSettingsChange, defaultHiddenColumns = [],}) => {
  const [show, setShow] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  return (
    <>
      <SportTooltip title="Настройка колонок таблицы">
        <Button onClick={() => setShow(true)} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
          <img
            src={isHovered ? "/images/settings-white.svg" : "/images/settings-green.svg"}
            alt="settings"
          />
        </Button>
      </SportTooltip>
      {show && (
        <TableSettings
          onClose={() => setShow(false)}
          columns={tblGetColumns(columns, name, defaultHiddenColumns)}
          name={name}
          onSettingsChange={onSettingsChange}
        />
      )}
    </>
  );
};
